<template>
  <div class="block">
    <span class="demonstration">折叠展示Tag</span>
    <el-cascader
      :options="options"
      :props="props"
      collapse-tags
      clearable
      @change="handleCascaderChange">
    </el-cascader>
  </div>
</template>

<script>
export default {
  data() {
    return {
      props: { multiple: true },
      selectedValues: [],
      options: [{
        value: '1',
        label: '东南',
        children: [{
          value: '2',
          label: '上海',
        }, {
          value: '7',
          label: '江苏',
        }, {
          value: '12',
          label: '浙江',
        }]
      }, {
        value: '17',
        label: '西北',
        children: [{
          value: '18',
          label: '陕西',
        }, {
          value: '21',
          label: '新疆维吾尔族自治区',
        }]
      }]
    };
  },
  methods: {
    handleCascaderChange(value) {
      if (value && value.length > 0) {
        const selectedParentValues = [];
        this.options.forEach(option => {
          const childrenValues = option.children.map(child => child.value);
          if (childrenValues.every(val => value.includes(val))) {
            selectedParentValues.push(option.value);
          }
        });
        this.selectedValues = selectedParentValues.length > 0 ? selectedParentValues : value;
        console.log(this.selectedValues )
      } else {
        this.selectedValues = [];
      }

    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/diyu.vue